export default __webpack_public_path__ + "static/media/Swap-Black.74641b54.png";